import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactComponent as EmptyHistory } from 'src/assets/images/catalog/empty-item.svg';
import { ReactComponent as Icon } from 'src/assets/images/fortune/ic-nookpoint.svg';
import { formatNumber } from 'src/lib/format-number';
import { FortuneExchangedItem } from 'src/models/fortune/FortuneExchangedItem';
import { FortuneExchangeHistoryListItem } from './FortuneExchangeHistoryListItem';

interface FortuneExchangeHistoryContentProps {
  histories: FortuneExchangedItem[];
  totalGotPoint: number;
}

export const FortuneExchangeHistoryContent: React.FC<FortuneExchangeHistoryContentProps> = ({
  histories,
  totalGotPoint
}) => {
  const history = useHistory();
  const { t, i18n } = useTranslation('fortune');
  const handleClick = useCallback(
    (index: number) => {
      history.push(`/players/fortune/exchange-history/detail/${index}`);
    },
    [history]
  );

  const isEmpty = histories.length === 0;

  return (
    <div
      className={css`
        width: 100%;
        max-width: 480px;
        overflow: auto;
        margin: 24px auto;

        .total-got-point {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: #938666;
          margin: 0 16px 24px;
        }
        .description {
          font-size: 14px;
          color: #4d3906;
          margin: 0 24px;
        }
        .list {
          display: flex;
          flex-direction: column;
        }
        .footer {
          flex: 0 0 auto;
          margin: 24px;
        }
        .notice {
          color: #938666;
          font-size: 12px;
          text-align: center;
        }
        .notice-empty {
          font-size: 14px;
          color: #4d3906;
          text-align: center;
        }
      `}
    >
      <div className="total-got-point">
        <span>{t('total_got_point')}</span>
        <Icon width={24} height={24} style={{ margin: '0 2px' }} />
        <span>{formatNumber(totalGotPoint, i18n.language)}</span>
      </div>

      <p className="description"> {t('recently_exchanged_items')}</p>
      {isEmpty ? (
        <FortuneExchangeHistoryEmpty />
      ) : (
        <ul className="list">
          {histories.map((item, i) => (
            <FortuneExchangeHistoryListItem
              key={i}
              exchangedItem={item}
              index={i}
              onClick={handleClick}
            />
          ))}
        </ul>
      )}
      <div className="footer">
        {isEmpty ? (
          <p className="notice-empty">{t('empty_no_exchange_history_desc')}</p>
        ) : (
          <p className="notice">{t('notice_show_up_to_100')}</p>
        )}
      </div>
    </div>
  );
};

const FortuneExchangeHistoryEmpty: React.FC = () => {
  const { t } = useTranslation('fortune');
  return (
    <div
      className={css`
        margin-top: 16px;
        padding: 0 24px;
      `}
    >
      <div
        className={css`
          display: flex;
          justify-content: center;
          align-items: center;
          border-top: 2px dashed #dcd8bf;
          border-bottom: 2px dashed #dcd8bf;
          padding: 16px;
          margin: 0 auto;
          h2 {
            font-size: 16px;
            margin: 0 0 0 16px;
            color: #4d3906;
          }
        `}
      >
        <EmptyHistory style={{ flex: '0 0 auto' }} />
        <h2>{t('empty_no_exchange_history')}</h2>
      </div>
    </div>
  );
};
